export default __webpack_public_path__ + "static/media/project_logo.8dd5635e.png";